import { StyledTextField } from '.';
import { type ChangeEvent, type FocusEvent, type ReactNode, useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface InputProps {
    label?: string | ReactNode;
    type?: 'text' | 'number' | 'checkbox' | 'date' | 'password' | 'email' | 'phone' | 'textarea' | 'time' | 'color' | 'unknown' | 'autocomplete' | 'quill';
    disabled: boolean;
    placeholder: string;
    error: boolean;
    value: string | number | boolean | Date | unknown[];
    onChange: ((event: ChangeEvent<HTMLInputElement>) => void);
    onBlur: (event: FocusEvent<HTMLInputElement>) => void;
    min?: string;
    [key: string]: unknown;
}

const TextFieldInput = ({
    label,
    type,
    placeholder,
    error,
    value,
    onChange,
    onBlur,
    disabled,
    ...props
}: InputProps) => {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <StyledTextField
            id={typeof label === 'string' ? (label).trim() : label?.toString()}
            type={type === 'password' && showPassword ? 'text' : type}
            multiline={type === 'textarea'}
            rows={type === 'textarea' ? 4 : 1}
            placeholder={placeholder}
            error={Boolean(error)}
            variant="outlined"
            disabled={disabled}
            value={value}
            aria-label={label as string}
            aria-invalid={Boolean(error)}
            onChange={onChange as ((event: ChangeEvent<HTMLInputElement>) => void)}
            onBlur={onBlur}
            // multiline={true}
            // rows={4}
            className={error ? '' : 'error'}
            sx={{
                height: 'auto',
                resize: 'initial'
            }}
            {...props}
            InputProps={{
                endAdornment:
                    type === 'password'
                        ? (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={handleTogglePasswordVisibility}
                                    edge="end"
                                    aria-label="toggle password visibility"
                                    sx={{
                                        border: 'none'
                                    }}
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        )
                        : null
            }}
        />
    );
};

export default TextFieldInput;